module.exports = __webpack_public_path__ + "img/invite-friends.e23e8e9b.svg";